import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const SLIDE_DURATION = 7000;

  function initSlider( $component ) {
    const $triggers = $component.find( '.benefit-slider__trigger' );
    if ( !$triggers.length ) return;

    function getAllTargetIds() {
      const ids = [];
      $triggers.each( function() {
        $( this ).data( 'target' ).split( ',' ).forEach( function( id ) {
          const trimmed = id.trim();
          if ( !ids.includes( trimmed ) ) ids.push( trimmed );
        } );
      } );
      return ids;
    }

    const allTargetIds = getAllTargetIds();

    function goToSlide( index ) {
      const $trigger = $triggers.eq( index );
      const activeIds = $trigger.data( 'target' ).split( ',' ).map( function( id ) {
        return id.trim();
      } );

      $triggers.each( function( i ) {
        const $content = $( this ).find( '.benefit-slider__content' );
        const $bar = $( this ).find( '.benefit-slider__progress-bar' );

        if ( i === index ) {
          $content.slideDown( 300 );
          $bar.stop( true, true ).css( {height: '0%'} ).animate(
              {height: '100%'},
              {
                duration: SLIDE_DURATION,
                easing: 'linear',
                complete: function() {
                  goToSlide( ( index + 1 ) % $triggers.length );
                },
              },
          );
        } else {
          $content.slideUp( 300 );
          $bar.stop( true, false ).css( {height: '0%'} );
        }
      } );

      allTargetIds.forEach( function( id ) {
        const $el = $( id );
        if ( activeIds.includes( id ) ) {
          $el.stop( true ).fadeIn( 400 );
        } else {
          $el.stop( true ).fadeOut( 400 );
        }
      } );
    }

    // Init: hide all images and content, then activate slide 0
    $component.find( '.benefit-slider__content' ).hide();
    $component.find( '.benefit-slider__image-wrap' ).hide();

    $triggers.on( 'click', function() {
      goToSlide( $triggers.index( this ) );
    } );

    goToSlide( 0 );
  }

  const COMPONENT = {
    init: function() {
      // Marquee
      if ( $( '.benefit-slider__marquee' ).length ) {
        $( '.benefit-slider__marquee' ).each( function( index, element ) {
          const marqueeText = $( element ).find( '.benefit-slider__marquee-text .marquee-text' );
          let marqueeTextWidth = 0;
          marqueeText.each( function( index, el ) {
            marqueeTextWidth = marqueeTextWidth + $( el ).outerWidth();
          } );
          const slider = new Splide( element, {
            type: 'loop',
            drag: 'free',
            gap: '0',
            arrows: false,
            fixedWidth: `${marqueeTextWidth}px`,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }

      // Trigger slider
      if ( $( '.benefit-slider' ).length ) {
        $( '.benefit-slider' ).each( function() {
          initSlider( $( this ) );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'benefit-slider', COMPONENT );
} )( app );
